"use strict";

var _interopRequireDefault = require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
require("core-js/modules/es7.object.get-own-property-descriptors");
require("core-js/modules/es6.object.keys");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
exports.filterAsyncRoutes = filterAsyncRoutes;
exports.filterServeAsyncRoutes = filterServeAsyncRoutes;
require("core-js/modules/es7.object.values");
require("core-js/modules/es6.function.name");
var _defineProperty2 = _interopRequireDefault(require("E:/dianlala_project/\u7535\u5566\u5566/cd-vue-admin/node_modules/@babel/runtime/helpers/defineProperty.js"));
require("core-js/modules/web.dom.iterable");
require("core-js/modules/es7.array.includes");
require("core-js/modules/es6.string.includes");
var _router = require("@/router");
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
/**
 * Use meta.role to determine if the current user has permission
 * @param roles
 * @param route
 */
function hasPermission(roles, route) {
  if (route.meta && route.meta.roles) {
    return roles.some(function (role) {
      return route.meta.roles.includes(role);
    });
  } else {
    return true;
  }
}

/**
 * Filter asynchronous routing tables by recursion
 * @param routes asyncRoutes
 * @param roles
 */
function filterAsyncRoutes(routes, roles) {
  var res = [];
  routes.forEach(function (route) {
    var tmp = _objectSpread({}, route);
    if (hasPermission(roles, tmp)) {
      if (tmp.children) {
        tmp.children = filterAsyncRoutes(tmp.children, roles);
      }
      res.push(tmp);
    }
  });
  return res;
}

/**
 根据后台权限过滤路由
 */
function filterServeAsyncRoutes(routes, rolesview) {
  var res = [];
  console.log(rolesview);
  routes.forEach(function (route) {
    var tmp = _objectSpread({}, route);
    if (hasServePermission(rolesview, tmp)) {
      if (tmp.children) {
        tmp.children = filterServeAsyncRoutes(tmp.children, rolesview);
      }
      res.push(tmp);
    }
  });
  return res;
}
function hasServePermission(rolesview, route) {
  if (route.name) {
    return rolesview.includes(route.name);
  } else {
    return true;
  }
}
var state = {
  routes: [],
  addRoutes: []
};
var mutations = {
  SET_ROUTES: function SET_ROUTES(state, routes) {
    state.addRoutes = routes;
    state.routes = _router.constantRoutes.concat(routes);
  }
};
var actions = {
  generateRoutes: function generateRoutes(_ref, roles) {
    var commit = _ref.commit;
    return new Promise(function (resolve) {
      var accessedRoutes;
      for (var i in _router.asyncRoutes) {
        if (agentInfo.agent_level == 5 && agentInfo.virtual_divide == 1) {
          if ((_router.asyncRoutes[i].path.indexOf('/home') > -1 || _router.asyncRoutes[i].path.indexOf('/order') > -1) && _router.asyncRoutes[i]['meta']['roles']) {
            _router.asyncRoutes[i]['meta']['roles'].splice(_router.asyncRoutes[i]['meta']['roles'].indexOf('merchants'), 1);
          }
        }
        if (agentInfo.check_order == 0 && _router.asyncRoutes[i].path == '/order') {
          _router.asyncRoutes[i]['meta']['roles'] = [''];
        }
        if (agentInfo.withdraw_right == 0 && _router.asyncRoutes[i].path == '/withdraw') {
          _router.asyncRoutes[i]['children'][4]['meta']['roles'] = [''];
          _router.asyncRoutes[i]['children'][4]['meta']['roles'] = [''];
          if (agentInfo.agent_level == 5) _router.asyncRoutes[i]['meta']['roles'] = [''];
        }
        if (_router.asyncRoutes[i].path == '/run') {
          if (deviceNameObj && Object.values(deviceNameObj).indexOf(0) == -1 && _router.asyncRoutes[i]['children'][3]) {
            _router.asyncRoutes[i]['children'][3]['meta']['roles'] = [''];
          }
        }
        if (_router.asyncRoutes[i].path == '/condom') {
          if (deviceNameObj && Object.values(deviceNameObj).indexOf(7) == -1) {
            _router.asyncRoutes[i]['meta']['roles'] = [''];
          }
        }
        if (_router.asyncRoutes[i].path == '/entity') {
          if (deviceNameObj && Object.values(deviceNameObj).length == 1 && Object.values(deviceNameObj).indexOf(0) > -1) {
            _router.asyncRoutes[i]['meta']['roles'] = [''];
          }
        }
        // if(asyncRoutes[i].path == '/setting'){
        //   if(deviceNameObj && Object.values(deviceNameObj).length == 1 && Object.values(deviceNameObj).indexOf(0) > -1){
        //     asyncRoutes[i]['children'][6]['meta']['roles'] = ['']
        //   }
        // }
        if (_router.asyncRoutes[i].path == '/wx') {
          if (siteInfo && !siteInfo.wx_third_api_switch) {
            _router.asyncRoutes[i].hidden = true;
          }
        }
        if (_router.asyncRoutes[i].path == '/station') {
          if (siteInfo && !siteInfo.wx_third_api_switch) {
            _router.asyncRoutes[i].hidden = true;
          }
        }
        if (_router.asyncRoutes[i].path == '/ali') {
          if (siteInfo && !siteInfo.zfb_third_api_switch) {
            _router.asyncRoutes[i].hidden = true;
          }
        }
      }
      if (roles.includes('admin')) {
        accessedRoutes = _router.asyncRoutes || [];
      } else {
        accessedRoutes = filterAsyncRoutes(_router.asyncRoutes, roles);
      }
      commit('SET_ROUTES', accessedRoutes);
      resolve(accessedRoutes);
    });
  },
  generateServiceRoutes: function generateServiceRoutes(_ref2, roles) {
    var commit = _ref2.commit;
    return new Promise(function (resolve) {
      var accessedRoutes;
      if (roles.includes('admin')) {
        accessedRoutes = _router.asyncRoutes || [];
      } else {
        accessedRoutes = filterServeAsyncRoutes(_router.asyncRoutes, roles);
      }
      commit('SET_ROUTES', accessedRoutes);
      resolve(accessedRoutes);
    });
  }
};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};